import type { CityConfig } from "@/pages/city-template/types";

export const poughkeepsieConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Poughkeepsie",
  state: "New York",
  stateAbbr: "NY",
  slug: "poughkeepsie",
  route: "/cities/poughkeepsie",
  title: "Emergency Passport Poughkeepsie, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Poughkeepsie, NY — as fast as 24 hours. Registered State Dept. courier serving Marist College, Vassar College, SWF/HPN/JFK travelers, and all Dutchess County communities with the best price guarantee.",
  h1: "Emergency & Expedited Passport Services in Poughkeepsie, NY",
  heroSubtitle: "Vassar semester abroad in Florence starting in 3 weeks? Marist study program in Dublin leaving soon? Hudson Valley family vacation to Italy booked last-minute? We help Poughkeepsie residents — from the college campuses to the Walkway Over the Hudson — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Poughkeepsie%20New%20York%20with%20the%20iconic%20Walkway%20Over%20the%20Hudson%20pedestrian%20bridge%20spanning%20the%20Hudson%20River%20at%20golden%20hour%2C%20Marist%20College%20and%20Vassar%20College%20campuses%20visible%20along%20the%20riverside%2C%20historic%20downtown%20Main%20Street%20with%20classic%20brick%20buildings%2C%20autumn%20foliage%20in%20rich%20orange%20and%20gold%20tones%20along%20the%20riverbanks%2C%20Hudson%20Valley%20hills%20in%20soft%20golden%20light%2C%20modern%20editorial%20travel%20photography%20with%20warm%20atmospheric%20tones%2C%20no%20text%20overlay%2C%20clean%20professional%20composition&width=1600&height=700&seq=poughkeepsie-hero-v2-001&orientation=landscape",
  heroImageAlt: "Poughkeepsie New York with Walkway Over the Hudson bridge and Hudson River at golden hour",
  geoPosition: "41.7004;-73.9209",
  geoPlacename: "Poughkeepsie, New York, United States",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~75 miles south in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Poughkeepsie", zips: "12601, 12602, 12603, 12604" },
    { name: "Wappingers Falls", zips: "12590" },
    { name: "Hyde Park", zips: "12538" },
    { name: "Rhinebeck", zips: "12572" },
    { name: "Fishkill", zips: "12524" },
    { name: "Beacon", zips: "12508" },
    { name: "Newburgh", zips: "12550, 12551, 12552, 12553, 12554, 12555" },
    { name: "Kingston", zips: "12401, 12402, 12411, 12429, 12432, 12441, 12449, 12484, 12485, 12487, 12490, 12491, 12492, 12496" },
    { name: "New Paltz", zips: "12561" },
    { name: "Middletown", zips: "10940, 10941" },
    { name: "Red Hook", zips: "12571" },
    { name: "LaGrange", zips: "12540" },
    { name: "Pleasant Valley", zips: "12569" },
    { name: "Millbrook", zips: "12545" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12250, 12252, 12255-12257, 12260-12262, 12288" },
    { name: "White Plains", zips: "10601, 10602, 10603, 10605, 10606, 10607, 10610" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Poughkeepsie-area travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "Tri-Airport Hudson Valley Access", desc: "SWF (15 miles), HPN (45 miles), JFK (80 miles). We know every airline timeline and international connection scenario from Dutchess County." },
    { icon: "ri-graduation-cap-line", title: "Marist & Vassar College Expertise", desc: "Two world-class colleges sending hundreds of students abroad each semester. We know the academic calendar, study-abroad deadlines, and first-time passport process." },
    { icon: "ri-landscape-line", title: "Hudson Valley Lifestyle", desc: "From the Walkway to the Culinary Institute, from Rhinebeck antiques to Beacon galleries — Hudson Valley residents travel internationally for culture, cuisine, and family." },
  ],
  internalLinks: [
    { name: "Fast passport services in New York City, NY", route: "/cities/new-york-city" },
    { name: "Expedited passport in Albany, NY", route: "/cities/albany-ny" },
    { name: "Quick passport services in White Plains, NY", route: "/cities/white-plains" },
    { name: "Urgent passport services in Newburgh, NY", route: "/cities/newburgh" },
    { name: "New York passport services overview", route: "/states/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Poughkeepsie and all of Dutchess County via secure registered courier with direct access to the New York Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Poughkeepsie residents can ship from any UPS Store, FedEx Office, or post office location across the Hudson Valley.",
  fpcOfficeDistance: "Serving Poughkeepsie, Wappingers Falls, Hyde Park, Rhinebeck, Fishkill, Beacon, and all Dutchess County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Poughkeepsie and the greater Hudson Valley. From the Marist and Vassar campuses along the Hudson River to the suburban communities of Wappingers Falls, Hyde Park, and Fishkill, from the historic villages of Rhinebeck and Red Hook to the arts destination of Beacon — we serve all of Dutchess County. Our courier service eliminates the need to drive 75 miles to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Poughkeepsie and all Dutchess County communities including Wappingers Falls, Hyde Park, Rhinebeck, Fishkill, Beacon, Red Hook, LaGrange, Pleasant Valley, and Millbrook. We also serve travelers departing from SWF, HPN, and JFK airports who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Poughkeepsie as simple as possible — with the efficiency Hudson Valley college students, Dutchess County families, and weekend travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Poughkeepsie travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Poughkeepsie travelers encounter unique passport issues — everything from SWF connection traps to study-abroad acceptance windows at Marist and Vassar. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Poughkeepsie travelers — from Marist undergrads to Vassar faculty to Hyde Park families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Poughkeepsie, NY? Here are the most common ones we hear from Hudson Valley area travelers.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
  servicesIntro: "Whether you need a renewal before a SWF flight to Dublin, an emergency passport for a last-minute study-abroad program, or a first-time passport for a Hudson Valley family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Poughkeepsie semester abroad orientation in 5 days? International funeral or medical crisis requiring immediate travel? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Hudson Valley area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Poughkeepsie residents renew fast — no agency visit required for most renewals. Perfect for Marist and Vassar faculty, Dutchess County families, and Hudson Valley professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Poughkeepsie residents through every step — from the Marist campus to Vassar College to Hyde Park — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Hudson Valley travel plans or study-abroad semester is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Dutchess County family vacation abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Hudson Valley professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel while your primary is in visa processing? Ideal for Marist and Vassar professors with overlapping research travel schedules and Hudson Valley international business travelers.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Hudson Valley travelers through the process so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Poughkeepsie NY", description: "Urgent passport processing for Poughkeepsie New York travelers with immediate departure needs from SWF or JFK." },
    { name: "Expedited Passport Renewal Poughkeepsie NY", description: "Fast passport renewal for Poughkeepsie New York residents with a previously-issued passport." },
    { name: "First-Time Passport Poughkeepsie NY", description: "New passport application services for Poughkeepsie New York residents applying for their first passport." },
    { name: "Child Passport Poughkeepsie NY", description: "Minor passport services for Poughkeepsie New York families with children under 16." },
    { name: "Name Change Passport Poughkeepsie NY", description: "Passport name correction after marriage, divorce, or legal name changes for Poughkeepsie residents." },
    { name: "Second Passport Poughkeepsie NY", description: "Second passport services for Poughkeepsie college faculty and Hudson Valley frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Kevin A.",
      location: "Marist College area, Poughkeepsie",
      rating: 5,
      text: "My Marist semester abroad in Florence was 3 weeks away and my passport renewal got returned for a photo error. Fast Passport Center reviewed everything, caught the issue, and got it back in 48 hours. The agent knew exactly what Marist's study-abroad office needed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Martinez Family",
      location: "Hyde Park, NY",
      rating: 5,
      text: "Planned a last-minute trip to visit family in Puerto Rico and realized our daughter's passport had expired. They walked us through the child passport process at the Poughkeepsie post office and it arrived in 5 days. Incredible service for Dutchess County families.",
      service: "Child Passport Renewal",
    },
    {
      name: "Maria G.",
      location: "Wappingers Falls, NY",
      rating: 5,
      text: "I needed a name change on my passport before a conference in Madrid. They handled the entire process remotely — I never had to visit an office. The document review was thorough and the timeline was spot-on.",
      service: "Name Change Passport",
    },
    {
      name: "David L.",
      location: "Rhinebeck, NY",
      rating: 5,
      text: "Third time using Fast Passport Center for Hudson Valley-to-Europe trips. We fly out of JFK and HPN regularly and they understand exactly how to coordinate the timeline. Won't use anyone else for our family's passport needs.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "poughkeepsie-1",
      name: "Poughkeepsie Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "55 Mansion Street",
      city: "Poughkeepsie",
      state: "NY",
      zip: "12601",
      phone: "845-471-5220",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown Poughkeepsie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Dutchess County passport acceptance facility. Passport photos available on-site. Appointment recommended — busiest in the county during college semester openings.",
      icon: "ri-mail-line",
    },
    {
      id: "poughkeepsie-2",
      name: "Wappingers Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "779 Route 9",
      city: "Wappingers Falls",
      state: "NY",
      zip: "12590",
      phone: "845-297-4334",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Wappingers Falls — south of Poughkeepsie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southern Dutchess County residents. Passport acceptance by appointment. Less crowded than Poughkeepsie Main during peak seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "poughkeepsie-3",
      name: "Fishkill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "738 Route 9",
      city: "Fishkill",
      state: "NY",
      zip: "12524",
      phone: "845-896-6800",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Fishkill — southwest of Poughkeepsie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Fishkill, Beacon, and southwestern Dutchess County. Walk-ins accepted but limited — arrive early for best availability.",
      icon: "ri-mail-line",
    },
    {
      id: "poughkeepsie-4",
      name: "Dutchess County Clerk — Passport Acceptance",
      type: "County Clerk Passport Acceptance",
      address: "22 Market Street",
      city: "Poughkeepsie",
      state: "NY",
      zip: "12601",
      phone: "845-486-2120",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Downtown Poughkeepsie — County Office Building",
      website: "https://www.dutchessny.gov/Departments/County-Clerk/Passports.htm",
      websiteLabel: "Dutchess County Clerk",
      notes: "County clerk passport acceptance — excellent option for first-time applicants. No passport photos on-site. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "poughkeepsie-5",
      name: "Rhinebeck Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Mill Street",
      city: "Rhinebeck",
      state: "NY",
      zip: "12572",
      phone: "845-876-3589",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Rhinebeck — north of Poughkeepsie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Rhinebeck, Red Hook, and northern Dutchess County. Limited appointment slots — book at least a week in advance during summer tourism season.",
      icon: "ri-mail-line",
    },
    {
      id: "poughkeepsie-6",
      name: "Marist College — Center for Multicultural Affairs",
      type: "Campus Passport Resource",
      address: "3399 North Road",
      city: "Poughkeepsie",
      state: "NY",
      zip: "12601",
      phone: "845-575-3000",
      hours: "Academic year: Mon–Fri 9:00 AM – 5:00 PM",
      distance: "Marist College Campus — Poughkeepsie",
      website: "https://www.marist.edu/international",
      websiteLabel: "Marist International Programs",
      notes: "Passport and visa resource center for Marist students. Study-abroad orientation includes passport guidance. First-time applicants should also visit a USPS acceptance facility.",
      icon: "ri-graduation-cap-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 75 miles to Manhattan Passport Agency", fpc: "Most Poughkeepsie travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Hudson Valley-Specific Guidance", agency: "Generic — no SWF/HPN/JFK, college, or Dutchess County expertise", fpc: "Full Hudson Valley/college/SWF-HPN-JFK knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming SWF Has Direct International Flights Beyond Dublin",
      description: "SWF offers Dublin via Aer Lingus but many travelers assume full international service. That London or Paris trip requires a JFK connection — and a valid passport at SWF check-in. Some Poughkeepsie travelers arrive at SWF without a passport, expecting domestic-only travel.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Poughkeepsie college students often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks during the 6–10 week study-abroad orientation window. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Drugstores",
      description: "Many Poughkeepsie CVS and Walgreens locations produce photos that fail State Department standards — especially background shadowing and size issues. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Dutchess County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Poughkeepsie travelers booking to Europe, Asia, or South America often do not know their passport must have 6 months remaining beyond the return date. Marist and Vassar study-abroad students are particularly vulnerable to this oversight.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Poughkeepsie clients ship from the UPS Store on Route 9 or FedEx on Main Street — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Poughkeepsie?", a: "We offer Poughkeepsie-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Poughkeepsie office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Poughkeepsie post office or the Dutchess County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Poughkeepsie address." },
    { q: "Where can I get a passport acceptance in Poughkeepsie?", a: "Poughkeepsie has acceptance facilities at the Main Post Office on Mansion Street, the Dutchess County Clerk at 22 Market Street, and nearby post offices in Wappingers Falls, Fishkill, and Rhinebeck. We maintain an updated list of Dutchess County facilities with hours, photo availability, and appointment options." },
    { q: "Does Marist or Vassar help with student passports?", a: "Marist's Center for Multicultural Affairs provides passport and visa resources for study-abroad students. Vassar's Office of International Programs offers similar guidance. However, neither handles expedited processing. Our courier service bridges the gap between campus guidance and actual fast passport processing." },
    { q: "What is the best price for expedited passport service in Poughkeepsie?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Poughkeepsie applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Dutchess County-specific checklist." },
    { q: "Can I get a passport photo in Poughkeepsie?", a: "Yes — many Poughkeepsie post offices, CVS, Walgreens, UPS Stores, and FedEx Office locations offer passport photos. The Poughkeepsie Main Post Office on Mansion Street has on-site photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Poughkeepsie passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Poughkeepsie to final return shipping typically matches your chosen speed tier." },
    { q: "Is Poughkeepsie near a passport agency?", a: "The New York Passport Agency is located at 376 Hudson Street in Manhattan — approximately 75 miles south. However, it only serves travelers with life-or-death emergencies. For standard expedited needs — even urgent ones — our courier channel is faster and more accessible than agency appointments." },
    { q: "Can you help with passports for SWF, HPN, or JFK travel?", a: "Yes. We regularly assist Poughkeepsie travelers with expedited passports for departures from all three airports. We understand the Hudson Valley to NYC corridor — from SWF in New Windsor to HPN in White Plains to JFK in Queens — and can coordinate timelines around your departure." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Poughkeepsie Residents",
    intro: "Poughkeepsie's position in the Hudson Valley — with two renowned colleges, a tri-airport dynamic, and a thriving tourism economy — creates distinct passport timing challenges. Here's what Poughkeepsie travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "SWF — New York Stewart International Airport",
        subtitle: "15 miles south — Hudson Valley's primary airport",
        description: "Stewart International offers direct flights to Dublin (Aer Lingus), Orlando, Fort Lauderdale, and major U.S. hubs. It is Poughkeepsie's most convenient airport — 15 miles down I-84. But SWF's limited international routes mean many travelers connect through JFK or Newark for long-haul flights, creating a passport trap: they book SWF for convenience, fly domestic, then discover at the connection gate that their passport is expired or missing.",
        tip: "SWF's Aer Lingus Dublin flight requires a valid passport at check-in. If you are connecting through another U.S. hub, you still need a valid passport at your point of departure.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "HPN — Westchester County Airport",
        subtitle: "45 miles south — regional alternative",
        description: "Westchester County Airport serves White Plains and the lower Hudson Valley with flights to major East Coast hubs. Some Poughkeepsie travelers prefer HPN over SWF or JFK for domestic connections to international gateways like Miami or Atlanta. But HPN is domestic-only — if your final destination is international, you need your passport sorted before you leave Poughkeepsie.",
        tip: "HPN's domestic-only status means you must have your passport ready before departure — there is no fixing passport issues at the HPN gate for an international connection.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Marist & Vassar College Study Abroad",
        subtitle: "Two world-class colleges sending hundreds abroad each semester",
        description: "Marist College sends over 500 students to 50+ countries annually through one of the largest study-abroad programs at a mid-size U.S. college. Vassar College has a similarly robust international program with exchange partnerships across Europe, Asia, and Latin America. The acceptance-to-departure window for both schools is typically 6–10 weeks — tight for standard passport processing. Many students — especially first-generation college students — have never held a passport and must apply from scratch at a Poughkeepsie acceptance facility.",
        tip: "First-time applicants must visit an acceptance facility in person. We guide Marist and Vassar students through the nearest facility with the earliest available appointment, so they do not miss their program orientation.",
      },
      {
        icon: "ri-landscape-line",
        title: "Hudson Valley Tourism & Seasonal Demand",
        subtitle: "Culinary Institute, Walkway Over the Hudson, Rhinebeck, Beacon",
        description: "Poughkeepsie is the geographic center of the Hudson Valley's tourism economy. The Culinary Institute of America attracts international culinary students and faculty. The Walkway Over the Hudson draws visitors from around the world. Rhinebeck's Dutchess County Fair, Beacon's Dia art museum, and the region's farm-to-table dining scene create year-round international travel demand — both inbound and outbound. Summer and fall are peak passport seasons as Hudson Valley residents book European river cruises, fall foliage tours, and winter getaways to the Caribbean.",
        tip: "Summer tourism season (June–September) overwhelms local acceptance facilities. Book your appointment at least 2 weeks in advance during peak season to avoid missing your travel window.",
      },
    ],
    callout: {
      icon: "ri-train-line",
      title: "Amtrak Empire Corridor & NYC Access",
      description: "Poughkeepsie's Amtrak station on the Empire Corridor provides direct rail service to New York Penn Station in 90 minutes. Many Poughkeepsie residents use Amtrak to connect to JFK or Newark for international flights — but the Amtrak convenience can create a false sense of time. A passport issue discovered at Penn Station, 90 minutes from home, with an international flight in 3 hours, is a travel disaster.",
    },
  },
  destinations: {
    title: "Where Poughkeepsie Travelers Go — And Why Passports Get Urgent",
    intro: "Poughkeepsie's twin-college town character and Hudson Valley location create a unique international travel profile. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "45%", label: "of Poughkeepsie expedited requests are college/academic-related with 4–8 week acceptance windows" },
      { stat: "3–6 Weeks", label: "average lead time Poughkeepsie travelers have from trip booking to international departure" },
      { stat: "Jun–Sep", label: "peak season when summer tourism, study-abroad prep, and family vacations collide" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for a Marist student departing to Florence" },
    ],
    destinations: [
      { name: "Italy", context: "Marist Florence campus, Vassar study abroad, Hudson Valley food & wine travelers, Culinary Institute connections", urgency: "Study-abroad semesters lock in 6–10 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Ireland", context: "SWF Dublin direct flight, Irish heritage strong in Hudson Valley, Marist Dublin program", urgency: "Aer Lingus direct route — travelers often book fare sales 4–6 weeks out", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "Vassar London exchange, Hudson Valley antiques trade, academic conferences, family heritage travel", urgency: "Academic conference dates are fixed and immovable", icon: "ri-map-pin-2-line" },
      { name: "France", context: "Marist Paris program, Vassar French department, CIA culinary students staging in French kitchens", urgency: "French student visa timeline adds 2–4 weeks to the process", icon: "ri-map-pin-2-line" },
      { name: "Spain", context: "Marist Madrid and Barcelona programs, Hudson Valley travelers on Camino de Santiago, spring break", urgency: "Spring semester acceptance letters arrive November — departure is January", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "JFK direct flights, Dutchess County winter escapes, family spring break, destination weddings", urgency: "Last-minute all-inclusive deals booked 3–4 weeks out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Hudson Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Hudson Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Newburgh", route: "/cities/newburgh" },
      { name: "Kingston", route: "/cities/kingston" },
      { name: "Beacon", route: "/cities/beacon" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Poughkeepsie", address: "252 Main Street, Poughkeepsie, NY 12601", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Poughkeepsie", address: "709 Main Street, Poughkeepsie, NY 12601", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Poughkeepsie Plaza", address: "2600 South Road, Poughkeepsie, NY 12601", hours: "Mon–Fri 8:30 AM – 7:00 PM, Sat 9:00 AM – 5:00 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "FedEx Office — Poughkeepsie", address: "3434 North Road, Poughkeepsie, NY 12601", hours: "Mon–Fri 8:00 AM – 9:00 PM, Sat–Sun 10:00 AM – 6:00 PM", website: "https://www.office.fedex.com/default/office" },
    { name: "Walmart Photo Center — Fishkill", address: "56 West Merritt Boulevard, Fishkill, NY 12524", hours: "Daily 7:00 AM – 10:00 PM", website: "https://www.walmart.com/photo" },
    { name: "CVS Pharmacy — Wappingers Falls", address: "1565 Route 9, Wappingers Falls, NY 12590", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Poughkeepsie Main Post Office Photo", address: "55 Mansion Street, Poughkeepsie, NY 12601", hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM", website: "https://tools.usps.com/find-location.htm" },
    { name: "Walgreens — Hyde Park", address: "4250 Albany Post Road, Hyde Park, NY 12538", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Poughkeepsie",
      address: "13 Corporate Park Drive, Poughkeepsie, NY 12601",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Poughkeepsie DMV office for license renewals and REAL ID applications. Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Wappingers Falls",
      address: "29 Marshall Road, Wappingers Falls, NY 12590",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Wappingers Falls DMV office serving south Poughkeepsie, Wappingers Falls, and Fishkill residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "New York Stewart International Airport",
      distance: "~15 miles from Poughkeepsie",
      address: "1 Airport Road, New Windsor, NY 12553",
      note: "Hudson Valley's primary airport with direct flights to Dublin, Orlando, and major U.S. hubs. Most convenient for Poughkeepsie and Dutchess County travelers.",
      flightUrl: "https://www.swcairport.com/",
      flightLabel: "SWF Airport",
      featured: true,
    },
    {
      code: "HPN",
      name: "Westchester County Airport",
      distance: "~45 miles from Poughkeepsie",
      address: "240 Airport Road, White Plains, NY 10604",
      note: "Regional airport with domestic connections to international gateways. Alternative for lower Hudson Valley travelers.",
      flightUrl: "https://airport.westchestergov.com/",
      flightLabel: "HPN Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records in Albany. Online, mail, or in-person options for Dutchess County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Records. Required for estate and legal matters in Dutchess County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Dutchess County Clerk at 22 Market Street. Certified copies available for name changes and legal purposes.",
      url: "https://www.dutchessny.gov/Departments/County-Clerk/County-Clerk.htm",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Dutchess County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/9jd/dutchess/",
    },
  ],
};

export default poughkeepsieConfig;